export default __webpack_public_path__ + "static/media/171216ayatori_123.212542d6.jpg";